export const COMPARE_IMAGE_WITH_DESCRIPTION_MAX_ANSWER_ATTEMPTS = 1;
